module.exports = "/assets/src/client/assets/topLevelPage/styled-Dots.svg";